import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import UserflowTheme from '@lt/components/themes/userflow';
import UIGlobalStyles from '@lt/components/styles/styles';
import ErrorBoundary from 'src/error/components/ErrorBoundary';

import Layout from 'src/components/Layout';
import Routes from './routes';
import { MODULE_NAME, PACKAGES_PATH } from '../../../../constants';

import getStore from './store';

const PackageCheckoutApp = (props) => {
  const history = createBrowserHistory({ basename: PACKAGES_PATH });

  return (
    <ErrorBoundary>
      <Provider store={getStore(props, history)}>
        <UIGlobalStyles />
        <UserflowTheme>
          <Layout {...props} appName={MODULE_NAME.PACKAGE_CHECKOUT}>
            <Routes history={history} />
          </Layout>
        </UserflowTheme>
      </Provider>
    </ErrorBoundary>
  );
};

/* eslint-disable react/no-unused-prop-types */
PackageCheckoutApp.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  package: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  hotel: PropTypes.shape({}).isRequired,
  data: PropTypes.shape({}).isRequired,
  client: PropTypes.shape({}).isRequired,
  // testimonials: TestimonialsPropTypes.items, // TODO: сделать рабочим проптайп
};
/* eslint-enable react/no-unused-prop-types */

export default PackageCheckoutApp;
